import { Box, Stack, Typography } from '@mui/material';
import { SmallLoader } from 'framework/ui/mui-builder';
import type { SyberryTodayProjectAllocationSummary } from 'domain/people/syberryToday/types';
import SyberryTodayAllocationGuidance from './SyberryTodayAllocationGuidance';
import SyberryTodayAllocationScale from './SyberryTodayAllocationScale';

type SyberryTodayAllocationSummaryProps = {
  allocationSummary: Nullable<SyberryTodayProjectAllocationSummary>;
  isLoading: boolean;
  isError: boolean;
};

const SyberryTodayAllocationSummary = ({
  allocationSummary,
  isLoading,
  isError,
}: SyberryTodayAllocationSummaryProps) => {
  if (isLoading) {
    return (
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 1.5 }}>
        <SmallLoader />
        <Typography variant="body2" color="textSecondary">
          Loading allocation guidance...
        </Typography>
      </Stack>
    );
  }

  if (isError) {
    return (
      <Typography variant="body2" color="textSecondary" mt={1.5}>
        Allocation guidance is unavailable.
      </Typography>
    );
  }

  if (!allocationSummary) {
    return null;
  }

  return (
    <Box sx={{ mt: 0.75, maxWidth: 300 }}>
      <Typography variant="body2" color="textSecondary">
        Allocation: {allocationSummary.allocationLabel}
      </Typography>

      <Box sx={{ mt: 2 }}>
        <Typography variant="body1" color="textSecondary" mb={0.75}>
          Weekly allocation
        </Typography>
        <SyberryTodayAllocationScale allocationSummary={allocationSummary} />
      </Box>

      <SyberryTodayAllocationGuidance allocationSummary={allocationSummary} />
    </Box>
  );
};

export default SyberryTodayAllocationSummary;
